// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ftmPage {
  padding: 18px 22px 34px;
  color: var(--text-body, #334155);
}

.ftmHeader,
.ftmBuilderTopbar {
  display: flex;
  align-items: center;
  gap: 14px;
}

.ftmHeader {
  justify-content: space-between;
  margin-bottom: 14px;
}

.ftmEyebrow {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.ftmHeader h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 26px;
  font-weight: 800;
}

.ftmPage--modern {
  padding: 0 0 34px;
}

.ftmPage--modern .ftmHeader {
  width: calc(100% + 48px);
  min-height: 86px;
  margin: -20px -24px 22px;
  padding: 14px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}

.ftmPage--modern .ftmHeader h1 {
  font-size: 22px;
}

.ftmPage--modern .ftmHeader > .ftmTabs {
  min-width: 0;
  flex: 1 1 auto;
  align-self: stretch;
  margin: 0;
  border-bottom: 0;
}

.ftmPage--modern .ftmHeader > .ftmTabs button {
  position: relative;
  height: 100%;
  padding: 0 16px;
  border-bottom: 0;
}

.ftmPage--modern .ftmHeader > .ftmTabs button::after {
  position: absolute;
  right: 0;
  bottom: -14px;
  left: 0;
  height: 3px;
  background: transparent;
  content: '';
}

.ftmPage--modern .ftmHeader > .ftmTabs button.isActive::after {
  background: var(--blue-500, #227ebd);
}

.ftmMainCard {
  min-width: 0;
}

.ftmPage--modern .ftmMainCard {
  width: 100%;
  padding: 18px 20px 22px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);
}

.ftmHeaderActions,
.ftmControls,
.ftmRowActions,
.ftmRoleChips,
.ftmTags,
.ftmColorControl,
.ftmCreateTypes,
.ftmTagRename {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ftmTabs {
  display: flex;
  align-items: center;
  gap: 6px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  margin-bottom: 16px;
}

.ftmTabs button {
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  padding: 11px 14px 10px;
}

.ftmTabs button.isActive {
  border-bottom-color: var(--action-primary, #2563eb);
  color: var(--text-strong, #0f172a);
}

.ftmTabs span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  margin-left: 6px;
  padding: 0 7px;
  border-radius: 999px;
  background: var(--slate-100, #f1f5f9);
  color: var(--text-muted, #64748b);
  font-size: 12px;
}

.ftmButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  border: 1px solid transparent;
  border-radius: var(--radius-md, 8px);
  cursor: pointer;
  font-size: 13px;
  font-weight: 700;
  padding: 0 13px;
  white-space: nowrap;
}

.ftmButton:disabled,
.ftmIconButton:disabled {
  cursor: default;
  opacity: 0.55;
}

.ftmButton--primary {
  background: var(--action-primary, #2563eb);
  color: #fff;
}
.ftmButton--secondary {
  background: #fff;
  border-color: var(--border-default, #cbd5e1);
  color: var(--text-strong, #0f172a);
}
.ftmButton--ghost {
  background: transparent;
  border-color: var(--border-subtle, #e2e8f0);
  color: var(--text-body, #334155);
}
.ftmButton--dangerGhost {
  background: #fff;
  border-color: #fecdd3;
  color: #be123c;
}
.ftmButton--sm {
  min-height: 30px;
  padding: 0 10px;
  font-size: 12px;
}
.ftmButton--block {
  width: 100%;
}
.ftmFilterButton.isActive {
  border-color: var(--action-primary, #2563eb);
  background: var(--blue-50, #eff6ff);
  color: var(--action-primary, #2563eb);
}
.ftmToolbarIconButton {
  width: 36px;
  height: 36px;
}
.ftmFilterCount {
  display: inline-flex;
  min-width: 18px;
  height: 18px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0 5px;
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
  font-size: 11px;
  line-height: 1;
}
.ftmColumns {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ftmColumnsIcon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-block;
  background: currentColor;
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E")
    center / 16px 16px no-repeat;
  -webkit-mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E")
    center / 16px 16px no-repeat;
}
.ftmColumnsMenu {
  position: absolute;
  z-index: 30;
  top: calc(100% + 2px);
  right: 0;
  min-width: 248px;
  padding: 8px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));
}
.ftmColumnsHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 7px 8px 9px;
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.ftmColumnsHeader button {
  border: 0;
  background: transparent;
  color: var(--text-link, #1a6da3);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  text-transform: none;
}
.ftmColumnsMenu label {
  display: flex;
  min-height: 34px;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border-radius: var(--radius-sm, 6px);
  color: var(--text-body, #334155);
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
}
.ftmColumnsMenu label:hover {
  background: var(--surface-hover, #f8fafc);
}
.ftmColumnsMenu label.isLocked {
  color: var(--text-subtle, #94a3b8);
  cursor: default;
}
.ftmColumnsMenu input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: var(--action-primary, #227ebd);
}
.ftmFilterIcon {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  display: inline-block;
  background: currentColor;
  mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E")
    center / 16px 16px no-repeat;
  -webkit-mask: url("data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E")
    center / 16px 16px no-repeat;
}

.ftmIconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-muted, #64748b);
  cursor: pointer;
}

.ftmIconButton:hover {
  background: var(--slate-50, #f8fafc);
  color: var(--text-strong, #0f172a);
}
.ftmIconButton--outlined {
  border-color: var(--border-default, #cbd5e1);
  color: var(--text-strong, #0f172a);
}
.ftmIconButton--danger {
  color: #dc2626;
}
.ftmIconButton--danger:hover {
  background: #fef2f2;
  color: #b91c1c;
}

.ftmTypeGrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.ftmTypeCard,
.ftmTypeChoice {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: inherit;
  cursor: pointer;
  padding: 10px 12px;
  text-align: left;
  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;
}
.ftmTypeCard.isActive {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  box-shadow: 0 0 0 1px var(--border-brand, #6fb1df);
}

.ftmTypeCard:hover,
.ftmTypeChoice:hover {
  border-color: var(--border-default, #cbd5e1);
  box-shadow: var(--shadow-md, 0 8px 20px rgba(15, 23, 42, 0.08));
  transform: translateY(-1px);
}

.ftmTypeIcon,
.ftmNameIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}

.ftmTypeIcon {
  width: 34px;
  height: 34px;
  border-radius: var(--radius-md, 8px);
}
.ftmNameIcon {
  width: 32px;
  height: 32px;
  border-radius: 9px;
}
.ftmTypeCard strong,
.ftmTypeChoice strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}
.ftmTypeCard small,
.ftmTypeChoice small {
  display: block;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  margin-top: 1px;
}

.ftmControls {
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.ftmControlsSpacer {
  flex: 1;
}

.ftmSearchField {
  display: block;
  width: 260px;
}

.ftmSearchField input,
.ftmControls select,
.ftmField input,
.ftmTagRename input[type='text'],
.ftmTagRename input:not([type]) {
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--text-strong, #0f172a);
  font-family: inherit;
  font-size: 13px;
  width: 100%;
}
.ftmSearchField input {
  height: var(--control-h-md, 40px);
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  padding: 0 12px;
  font-size: var(--text-md, 14px);
  box-shadow: none;
}
.ftmSearchField input:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}

.ftmControls select {
  width: auto;
  min-width: 160px;
  height: 36px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  padding: 0 30px 0 10px;
}

.ftmCard {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-lg, 12px);
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.ftmTableCard {
  overflow: visible;
}
.ftmTable {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.ftmTable th {
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  padding: 11px 14px;
  text-align: left;
  text-transform: uppercase;
}
.ftmTable td {
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  font-size: 13px;
  padding: 13px 14px;
  vertical-align: middle;
}
.ftmTable tbody tr {
  cursor: pointer;
}
.ftmTable tbody tr:hover {
  background: var(--slate-25, #fbfdff);
}
.ftmTable tbody tr:last-child td {
  border-bottom: 0;
}
.ftmTable th:last-child,
.ftmTable td:last-child {
  text-align: right;
  width: 1%;
  white-space: nowrap;
}

.ftmNameCell {
  display: flex;
  align-items: center;
  gap: 10px;
}
.ftmNameCell strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-weight: 700;
}
.ftmNameCell small,
.ftmAudit span {
  display: block;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  margin-top: 1px;
}
.ftmAudit strong {
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 500;
}

.ftmTags {
  flex-wrap: wrap;
}
.ftmTagChip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 22px;
  border: 1px solid transparent;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  padding: 4px 9px;
  white-space: nowrap;
}
.ftmTagChipButton {
  cursor: pointer;
}
.ftmTagDot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
  opacity: 0.75;
}
.ftmTagRemove {
  border: 0;
  background: transparent;
  color: inherit;
  cursor: pointer;
  font-weight: 800;
  opacity: 0.65;
  padding: 0;
}
.ftmTagRemove:hover {
  opacity: 1;
}

.ftmStatusBadge,
.ftmTypeBadge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 24px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  padding: 0 10px;
}
.ftmStatusBadge {
  background: var(--badge-neutral-bg, var(--slate-100, #f1f5f9));
  color: var(--badge-neutral-text, var(--text-muted, #64748b));
}
.ftmTypeBadge--info {
  background: var(--badge-info-bg, var(--blue-50, #eef6fc));
  color: var(--badge-info-text, var(--blue-700, #155d8c));
}
.ftmStatusBadge--default {
  background: var(--badge-info-bg, var(--blue-50, #eef6fc));
  color: var(--badge-info-text, var(--blue-700, #155d8c));
}

.ftmMuted {
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.ftmBanner {
  border-radius: var(--radius-md, 8px);
  margin-bottom: 12px;
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
}
.ftmBanner--warning {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
}

.ftmEmpty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 190px;
  color: var(--text-muted, #64748b);
  padding: 30px;
  text-align: center;
}
.ftmEmpty svg {
  color: var(--slate-300, #cbd5e1);
  font-size: 28px;
  margin-bottom: 4px;
}
.ftmEmpty strong {
  color: var(--text-strong, #0f172a);
}

.ftmTagsLayout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 18px;
  align-items: start;
}
.ftmCardHeader {
  padding: 16px 18px 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.ftmCardHeader--toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.ftmCardHeader h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 16px;
  font-weight: 800;
}
.ftmCardHeader p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 12px;
}
.ftmTagSearch {
  width: 230px;
  flex: 0 0 230px;
}
.ftmTagRows {
  padding: 0 18px;
}
.ftmTagRow {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 58px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}
.ftmTagRow:first-child {
  border-top: 0;
}
.ftmTagGrip {
  color: var(--slate-300, #cbd5e1);
  cursor: grab;
  font-size: 14px;
  letter-spacing: -2px;
}
.ftmTagRowSpacer {
  flex: 1;
}
.ftmTagUsage {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  white-space: nowrap;
}
.ftmTagRename {
  flex: 1;
}
.ftmTagRename input:not([type='color']) {
  height: 34px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  padding: 0 10px;
}
.ftmTagRename input[type='color'],
.ftmColorControl input[type='color'] {
  width: 38px;
  height: 32px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 7px;
  background: #fff;
  padding: 2px;
}
.ftmTagCreateCard {
  padding: 0 18px 18px;
}
.ftmTagCreateCard .ftmCardHeader {
  margin: 0 -18px 16px;
}
.ftmColorControl span {
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}

.ftmField {
  margin-bottom: 14px;
}
.ftmField label,
.ftmFieldLabel {
  display: block;
  color: var(--text-body, #334155);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 6px;
}
.ftmField input:not([type='color']) {
  height: 38px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  padding: 0 11px;
}
.ftmField select {
  width: 100%;
  height: 38px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: #fff;
  color: var(--text-strong, #0f172a);
  padding: 0 32px 0 11px;
  font-family: inherit;
  font-size: 13px;
}
.ftmField select:disabled {
  background-color: var(--slate-50, #f8fafc);
  color: var(--text-body, #334155);
  opacity: 1;
}
.ftmField input:disabled {
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
}

.ftmBuilderPage {
  min-height: calc(100vh - 76px);
  background: var(--surface-page, #f8fafc);
}
.ftmBuilderTopbar {
  position: sticky;
  top: 0;
  z-index: 8;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
  padding: 12px 22px;
}
.ftmBuilderBackLink {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 7px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--blue-700, #155d8c);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}
.ftmBuilderBackLink span {
  font-size: 19px;
  line-height: 1;
}
.ftmBuilderBackLink:hover {
  color: var(--action-primary-hover, #176da6);
  text-decoration: underline;
}
.ftmBuilderBackLink:disabled {
  cursor: default;
  opacity: 0.55;
}
.ftmBuilderBackDivider {
  width: 1px;
  height: 22px;
  flex: 0 0 1px;
  background: var(--border-subtle, #e2e8f0);
}
.ftmBuilderName {
  min-width: 280px;
  border: 1px solid transparent;
  border-radius: var(--radius-sm, 6px);
  background: transparent;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, inherit);
  font-size: 17px;
  font-weight: 800;
  outline: 0;
  padding: 4px 8px;
}
.ftmBuilderName:hover {
  border-color: var(--border-subtle, #e2e8f0);
}
.ftmBuilderName:focus {
  border-color: var(--border-brand, #2563eb);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.16));
  background: #fff;
}
.ftmBuilderMeta {
  color: var(--text-muted, #64748b);
  font-size: 12px;
}
.ftmBuilderSpacer {
  flex: 1;
}
.ftmBuilderSettings {
  display: grid;
  grid-template-columns: minmax(180px, 1.1fr) minmax(160px, 0.8fr) minmax(220px, 1fr) minmax(280px, 1.4fr);
  gap: 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: #fff;
  padding: 16px 22px;
}
.ftmRolesPanel,
.ftmTagsPanel {
  min-width: 0;
}
.ftmRoleChips {
  flex-wrap: wrap;
}
.ftmRoleChip {
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-muted, #64748b);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  min-height: 28px;
  padding: 0 10px;
}
.ftmRoleChip.isActive {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #155b8f);
}
.ftmRoleChip:hover {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
}
.ftmTagEditorGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}
.ftmTagEditorBox {
  min-height: 58px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--slate-25, #fbfdff);
  padding: 10px;
}
.ftmTagPicker {
  display: flex;
  min-height: 58px;
  align-content: flex-start;
  align-items: flex-start;
  gap: 7px;
  flex-wrap: wrap;
  padding: 10px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: var(--slate-25, #fbfdff);
}
.ftmTagPicker button {
  display: inline-flex;
  min-height: 30px;
  align-items: center;
  gap: 6px;
  padding: 0 10px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #334155);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
}
.ftmTagPicker button:hover {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
}
.ftmTagPicker button.isSelected {
  border-color: var(--action-primary, #227ebd);
  background: var(--blue-50, #eff6ff);
  color: var(--blue-700, #155b8f);
}
.ftmTagEditorTitle {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
  text-transform: uppercase;
}
.ftmBuilderSurface {
  padding: 18px 22px 34px;
}

.ftmDetailsGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}
.ftmDetailsHero {
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #dbeafe;
  border-radius: 10px;
  background: #f8fbff;
  padding: 14px;
}
.ftmDetailsTitle {
  color: var(--text-strong, #0f172a);
  font-size: 18px;
  font-weight: 800;
}
.ftmDetailsMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  margin-top: 5px;
}
.ftmDetailsCard {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}
.ftmDetailsCard--wide {
  grid-column: 1 / -1;
}
.ftmDetailsLabel {
  color: var(--text-muted, #64748b);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  margin-bottom: 4px;
  text-transform: uppercase;
}
.ftmDeleteModal {
  max-width: 480px;
}
.ftmDeleteBody {
  display: flex;
  align-items: flex-start;
  gap: 11px;
  text-align: left;
  white-space: normal;
}
.ftmDeleteIcon {
  display: inline-flex;
  width: 32px;
  height: 32px;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-sm, 6px);
  background: var(--red-50, #fdeef0);
  color: var(--red-600, #c23648);
  box-shadow: inset 0 0 0 1px var(--red-100, #f7cfd4);
  font-size: 15px;
  font-weight: 900;
}
.ftmHexInput {
  width: 96px !important;
  height: 34px !important;
  border: 1px solid var(--border-default, #cbd5e1) !important;
  border-radius: 7px !important;
  padding: 0 9px !important;
  font-family: ui-monospace, SFMono-Regular, Consolas, monospace !important;
}
.ftmColorPresets {
  display: flex;
  gap: 7px;
  flex-wrap: wrap;
  margin-top: 8px;
}
.ftmColorPresets button {
  width: 26px;
  height: 26px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 7px;
  box-shadow: 0 0 0 1px var(--border-default, #cbd5e1);
  cursor: pointer;
}
.ftmColorPresets button.isSelected {
  box-shadow: 0 0 0 2px var(--action-primary, #227ebd);
}
.ftmDeleteMessage {
  min-width: 0;
}
.ftmDeleteTitle {
  color: var(--text-strong, #0f172a);
  font-weight: 800;
  margin-bottom: 5px;
  overflow-wrap: anywhere;
}
.ftmDeleteText {
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.45;
}
.ftmDeleteModal .modal-header {
  padding: 13px 16px !important;
}
.ftmDeleteModal .modal-header button {
  width: 32px !important;
  height: 32px !important;
  border-radius: 8px !important;
}
.ftmDeleteModal .modal-body {
  padding: 15px 16px !important;
}
.ftmDeleteModal .modal-footer {
  padding: 10px 16px !important;
}
.ftmDeleteModal .modal-footer .btn {
  min-height: 34px !important;
  padding: 0 13px !important;
  border-radius: var(--radius-md, 8px) !important;
  font-size: 13px;
  font-weight: 700;
}
.ftmDeleteModal--danger .modal-footer .btn-primary {
  border-color: var(--red-500, #da4453) !important;
  background: var(--red-500, #da4453) !important;
  color: #fff !important;
}
.ftmDeleteModal--danger .modal-footer .btn-primary:hover {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
}
.ftmCreateTypes {
  align-items: stretch;
  flex-direction: column;
}

@media (max-width: 1100px) {
  .ftmTypeGrid,
  .ftmBuilderSettings,
  .ftmTagsLayout {
    grid-template-columns: 1fr;
  }
  .ftmControlsSpacer {
    display: none;
  }
}

@media (max-width: 760px) {
  .ftmPage {
    padding: 14px;
  }
  .ftmPage--modern {
    padding: 0 0 24px;
  }
  .ftmPage--modern .ftmHeader {
    width: calc(100% + 24px);
    min-height: 0;
    margin: -20px -12px 16px;
    padding: 14px 16px;
  }
  .ftmPage--modern .ftmMainCard {
    padding: 14px;
  }
  .ftmPage--modern .ftmHeader > .ftmTabs {
    width: 100%;
    min-height: 42px;
  }
  .ftmPage--modern .ftmHeader > .ftmTabs button::after {
    bottom: 0;
  }
  .ftmHeader,
  .ftmBuilderTopbar,
  .ftmControls {
    align-items: stretch;
    flex-direction: column;
  }
  .ftmBuilderBackLink {
    align-self: flex-start;
  }
  .ftmBuilderBackDivider {
    width: 100%;
    height: 1px;
    flex-basis: 1px;
  }
  .ftmHeaderActions {
    width: 100%;
  }
  .ftmHeaderActions .ftmButton {
    flex: 1;
  }
  .ftmSearchField,
  .ftmControls select,
  .ftmBuilderName {
    width: 100%;
    min-width: 0;
  }
  .ftmTable {
    min-width: 860px;
  }
  .ftmTableCard {
    overflow-x: auto;
  }
  .ftmTagEditorGrid,
  .ftmDetailsGrid {
    grid-template-columns: 1fr;
  }
}

.ftmHelpContent {
  display: grid;
  gap: 12px;
  text-align: left;
}

.ftmHelpContent div {
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 8px;
  background: #fff;
  padding: 12px;
}

.ftmHelpContent strong {
  display: block;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  margin-bottom: 4px;
}

.ftmHelpContent span {
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.45;
}

.ftmFilterOverlay {
  position: fixed;
  z-index: 1050;
  inset: 0;
  display: flex;
  justify-content: flex-end;
  background: rgba(15, 23, 42, 0.28);
}
.ftmFilterDrawer {
  display: flex;
  width: min(390px, 100vw);
  height: 100%;
  flex-direction: column;
  background: var(--surface-card, #fff);
  box-shadow: -12px 0 30px rgba(15, 23, 42, 0.16);
}
.ftmFilterHeader {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  margin: 18px 18px 0;
  padding: 0 0 12px;
}
.ftmFilterHeader h2 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 16px;
  font-weight: 800;
}
.ftmFilterHeader p {
  margin: 3px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.ftmFilterBody {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
.ftmFilterSection + .ftmFilterSection {
  margin-top: 22px;
}
.ftmFilterChips {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.ftmFilterChips button {
  min-height: 30px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 999px;
  background: #fff;
  color: var(--text-body, #334155);
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  padding: 0 11px;
}
.ftmFilterChips button.isActive {
  border-color: var(--action-primary, #227ebd);
  background: var(--action-primary, #227ebd);
  color: #fff;
}
.ftmTagListCard {
  overflow: visible;
}
.ftmTagToolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
}
.ftmTagToolbar .ftmSearchField {
  position: relative;
}
.ftmTagToolbar .ftmSearchField input {
  padding-right: 36px;
}
.ftmTagToolbar .ftmSearchField button {
  position: absolute;
  top: 50%;
  right: 7px;
  width: 28px;
  height: 28px;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.ftmTagToolbar .ftmSearchField button:hover {
  background: var(--slate-100, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.ftmTagTable th:nth-child(2),
.ftmTagTable td:nth-child(2) {
  width: 180px;
}
.ftmTagTable tbody tr {
  cursor: default;
}
.ftmTagModalBody {
  padding-top: 2px;
}
.ftmTagPreviewField {
  margin-bottom: 2px;
  padding: 12px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: var(--radius-md, 8px);
  background: var(--slate-25, #fbfdff);
}
.ftmTagChip--previewDisabled {
  border-color: var(--border-subtle, #e2e8f0) !important;
  background: var(--surface-sunken, #f1f5f9) !important;
  color: var(--text-subtle, #94a3b8) !important;
  opacity: 0.78;
}

.ftmRowActions {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.ftmRowEditButton,
.ftmRowMenuButton {
  display: inline-flex;
  height: 32px;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: var(--radius-md, 8px);
  background: var(--surface-card, #fff);
  color: var(--text-body, #334155);
  font-family: inherit;
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
}

.ftmRowEditButton {
  min-width: 52px;
  padding: 0 12px;
}

.ftmRowMenuButton {
  width: 34px;
  padding: 0;
  letter-spacing: 1px;
}

.ftmRowEditButton:hover,
.ftmRowMenuButton:hover,
.ftmRowMenuButton[aria-expanded='true'] {
  border-color: var(--border-brand, #6fb1df);
  background: var(--blue-50, #eef6fc);
  color: var(--blue-700, #155d8c);
}

.ftmRowMenu {
  position: absolute;
  z-index: 40;
  top: calc(100% + 5px);
  right: 0;
  width: 170px;
  padding: 6px;
  border: 1px solid var(--border-subtle, #dbe3ec);
  border-radius: 10px;
  background: var(--surface-card, #fff);
  box-shadow: var(--shadow-lg, 0 16px 36px rgba(15, 23, 42, 0.16));
  text-align: left;
}

.ftmRowMenu button {
  display: flex;
  width: 100%;
  min-height: 34px;
  align-items: center;
  padding: 7px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-body, #334155);
  font-family: inherit;
  font-size: 13px;
  font-weight: 650;
  text-align: left;
  cursor: pointer;
}

.ftmRowMenu button:hover {
  background: var(--surface-hover, #f1f5f9);
}

.ftmRowMenu button.isDanger {
  color: var(--red-600, #c4313f);
}

.ftmRowMenu button.isDanger:hover {
  background: var(--red-50, #fff1f2);
}
.ftmFilterFooter {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
  padding: 16px 20px;
}

.ftmFilterFooter > div {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ftmPagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 14px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
@media (max-width: 760px) {
  .ftmCardHeader--toolbar {
    align-items: stretch;
    flex-direction: column;
  }
  .ftmTagSearch {
    width: 100%;
    flex-basis: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/FormTemplatesManager/FormTemplatesManager.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;;;;;;;;EAQE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,2CAA2C;EAC3C,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;AACb;AACA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;EACd,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB;gCAC8B;EAC9B;gCAC8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,gEAAgE;AAClE;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,wBAAwB;EACxB;gCAC8B;EAC9B;gCAC8B;AAChC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;AACA;EACE,4CAA4C;EAC5C,kCAAkC;AACpC;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,+CAA+C;EAC/C,oCAAoC;EACpC,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,gFAAgF;AAClF;AACA;EACE,0CAA0C;EAC1C,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;;EAEE,4CAA4C;EAC5C,+DAA+D;EAC/D,2BAA2B;AAC7B;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;AACA;;EAEE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;;;EAKE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,WAAW;AACb;AACA;EACE,iCAAiC;EACjC,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,0CAA0C;EAC1C,mEAAmE;AACrE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,+CAA+C;EAC/C,qCAAqC;EACrC,qCAAqC;EACrC,8DAA8D;AAChE;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,sDAAsD;EACtD,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,sDAAsD;EACtD,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;AACf;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;AACA;EACE,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,8DAA8D;EAC9D,4DAA4D;AAC9D;AACA;EACE,yDAAyD;EACzD,uDAAuD;AACzD;AACA;EACE,yDAAyD;EACzD,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,sDAAsD;AACxD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mDAAmD;AACrD;AACA;EACE,aAAa;AACf;AACA;EACE,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,OAAO;AACT;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,eAAe;AACjB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,oCAAoC;EACpC,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,sDAAsD;EACtD,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,2CAA2C;EAC3C,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;AACA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,oCAAoC;EACpC,uBAAuB;EACvB,kCAAkC;EAClC,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,0CAA0C;EAC1C,kEAAkE;EAClE,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,OAAO;AACT;AACA;EACE,aAAa;EACb,wGAAwG;EACxG,SAAS;EACT,sDAAsD;EACtD,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,aAAa;EACb,+CAA+C;EAC/C,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;EAC5C,mCAAmC;AACrC;AACA;EACE,4CAA4C;EAC5C,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,eAAe;AACjB;AACA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,kCAAkC;EAClC,8BAA8B;EAC9B,mDAAmD;EACnD,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2DAA2D;EAC3D,6BAA6B;EAC7B,yBAAyB;EACzB,yEAAyE;AAC3E;AACA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;AACA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE;;;IAGE,0BAA0B;EAC5B;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,aAAa;IACb,wBAAwB;IACxB,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,SAAS;EACX;EACA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;IACE,OAAO;EACT;EACA;;;IAGE,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;;IAEE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,sDAAsD;EACtD,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,4CAA4C;EAC5C,0CAA0C;EAC1C,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,sDAAsD;AACxD;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,kCAAkC;AACpC;AACA;;EAEE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,+CAA+C;EAC/C,oCAAoC;EACpC,oCAAoC;AACtC;AACA;EACE,sDAAsD;EACtD,qDAAqD;EACrD,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;;EAEE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;EAChD,oCAAoC;EACpC,qCAAqC;EACrC,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;;;EAGE,0CAA0C;EAC1C,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE;IACE,oBAAoB;IACpB,sBAAsB;EACxB;EACA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF","sourcesContent":[".ftmPage {\n  padding: 18px 22px 34px;\n  color: var(--text-body, #334155);\n}\n\n.ftmHeader,\n.ftmBuilderTopbar {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n\n.ftmHeader {\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.ftmEyebrow {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.ftmHeader h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 26px;\n  font-weight: 800;\n}\n\n.ftmPage--modern {\n  padding: 0 0 34px;\n}\n\n.ftmPage--modern .ftmHeader {\n  width: calc(100% + 48px);\n  min-height: 86px;\n  margin: -20px -24px 22px;\n  padding: 14px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n\n.ftmPage--modern .ftmHeader h1 {\n  font-size: 22px;\n}\n\n.ftmPage--modern .ftmHeader > .ftmTabs {\n  min-width: 0;\n  flex: 1 1 auto;\n  align-self: stretch;\n  margin: 0;\n  border-bottom: 0;\n}\n\n.ftmPage--modern .ftmHeader > .ftmTabs button {\n  position: relative;\n  height: 100%;\n  padding: 0 16px;\n  border-bottom: 0;\n}\n\n.ftmPage--modern .ftmHeader > .ftmTabs button::after {\n  position: absolute;\n  right: 0;\n  bottom: -14px;\n  left: 0;\n  height: 3px;\n  background: transparent;\n  content: '';\n}\n\n.ftmPage--modern .ftmHeader > .ftmTabs button.isActive::after {\n  background: var(--blue-500, #227ebd);\n}\n\n.ftmMainCard {\n  min-width: 0;\n}\n\n.ftmPage--modern .ftmMainCard {\n  width: 100%;\n  padding: 18px 20px 22px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);\n}\n\n.ftmHeaderActions,\n.ftmControls,\n.ftmRowActions,\n.ftmRoleChips,\n.ftmTags,\n.ftmColorControl,\n.ftmCreateTypes,\n.ftmTagRename {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ftmTabs {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  margin-bottom: 16px;\n}\n\n.ftmTabs button {\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 11px 14px 10px;\n}\n\n.ftmTabs button.isActive {\n  border-bottom-color: var(--action-primary, #2563eb);\n  color: var(--text-strong, #0f172a);\n}\n\n.ftmTabs span {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 20px;\n  margin-left: 6px;\n  padding: 0 7px;\n  border-radius: 999px;\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n\n.ftmButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  min-height: 36px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-md, 8px);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 0 13px;\n  white-space: nowrap;\n}\n\n.ftmButton:disabled,\n.ftmIconButton:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n\n.ftmButton--primary {\n  background: var(--action-primary, #2563eb);\n  color: #fff;\n}\n.ftmButton--secondary {\n  background: #fff;\n  border-color: var(--border-default, #cbd5e1);\n  color: var(--text-strong, #0f172a);\n}\n.ftmButton--ghost {\n  background: transparent;\n  border-color: var(--border-subtle, #e2e8f0);\n  color: var(--text-body, #334155);\n}\n.ftmButton--dangerGhost {\n  background: #fff;\n  border-color: #fecdd3;\n  color: #be123c;\n}\n.ftmButton--sm {\n  min-height: 30px;\n  padding: 0 10px;\n  font-size: 12px;\n}\n.ftmButton--block {\n  width: 100%;\n}\n.ftmFilterButton.isActive {\n  border-color: var(--action-primary, #2563eb);\n  background: var(--blue-50, #eff6ff);\n  color: var(--action-primary, #2563eb);\n}\n.ftmToolbarIconButton {\n  width: 36px;\n  height: 36px;\n}\n.ftmFilterCount {\n  display: inline-flex;\n  min-width: 18px;\n  height: 18px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  padding: 0 5px;\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n  font-size: 11px;\n  line-height: 1;\n}\n.ftmColumns {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n.ftmColumnsIcon {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  display: inline-block;\n  background: currentColor;\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\")\n    center / 16px 16px no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='4' y='5' width='16' height='14' rx='2' fill='none' stroke='black' stroke-width='2'/%3E%3Cpath d='M9 5v14M15 5v14' stroke='black' stroke-width='2'/%3E%3C/svg%3E\")\n    center / 16px 16px no-repeat;\n}\n.ftmColumnsMenu {\n  position: absolute;\n  z-index: 30;\n  top: calc(100% + 2px);\n  right: 0;\n  min-width: 248px;\n  padding: 8px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 18px 40px rgba(15, 23, 42, 0.16));\n}\n.ftmColumnsHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 7px 8px 9px;\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.ftmColumnsHeader button {\n  border: 0;\n  background: transparent;\n  color: var(--text-link, #1a6da3);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  text-transform: none;\n}\n.ftmColumnsMenu label {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border-radius: var(--radius-sm, 6px);\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n}\n.ftmColumnsMenu label:hover {\n  background: var(--surface-hover, #f8fafc);\n}\n.ftmColumnsMenu label.isLocked {\n  color: var(--text-subtle, #94a3b8);\n  cursor: default;\n}\n.ftmColumnsMenu input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: var(--action-primary, #227ebd);\n}\n.ftmFilterIcon {\n  width: 16px;\n  height: 16px;\n  flex: 0 0 16px;\n  display: inline-block;\n  background: currentColor;\n  mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")\n    center / 16px 16px no-repeat;\n  -webkit-mask: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 6h16M7 12h10M10 18h4' stroke='black' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E\")\n    center / 16px 16px no-repeat;\n}\n\n.ftmIconButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n}\n\n.ftmIconButton:hover {\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-strong, #0f172a);\n}\n.ftmIconButton--outlined {\n  border-color: var(--border-default, #cbd5e1);\n  color: var(--text-strong, #0f172a);\n}\n.ftmIconButton--danger {\n  color: #dc2626;\n}\n.ftmIconButton--danger:hover {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.ftmTypeGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.ftmTypeCard,\n.ftmTypeChoice {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: inherit;\n  cursor: pointer;\n  padding: 10px 12px;\n  text-align: left;\n  transition: border-color 0.16s ease, box-shadow 0.16s ease, transform 0.16s ease;\n}\n.ftmTypeCard.isActive {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  box-shadow: 0 0 0 1px var(--border-brand, #6fb1df);\n}\n\n.ftmTypeCard:hover,\n.ftmTypeChoice:hover {\n  border-color: var(--border-default, #cbd5e1);\n  box-shadow: var(--shadow-md, 0 8px 20px rgba(15, 23, 42, 0.08));\n  transform: translateY(-1px);\n}\n\n.ftmTypeIcon,\n.ftmNameIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n}\n\n.ftmTypeIcon {\n  width: 34px;\n  height: 34px;\n  border-radius: var(--radius-md, 8px);\n}\n.ftmNameIcon {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n}\n.ftmTypeCard strong,\n.ftmTypeChoice strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n.ftmTypeCard small,\n.ftmTypeChoice small {\n  display: block;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  margin-top: 1px;\n}\n\n.ftmControls {\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.ftmControlsSpacer {\n  flex: 1;\n}\n\n.ftmSearchField {\n  display: block;\n  width: 260px;\n}\n\n.ftmSearchField input,\n.ftmControls select,\n.ftmField input,\n.ftmTagRename input[type='text'],\n.ftmTagRename input:not([type]) {\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font-family: inherit;\n  font-size: 13px;\n  width: 100%;\n}\n.ftmSearchField input {\n  height: var(--control-h-md, 40px);\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  padding: 0 12px;\n  font-size: var(--text-md, 14px);\n  box-shadow: none;\n}\n.ftmSearchField input:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n\n.ftmControls select {\n  width: auto;\n  min-width: 160px;\n  height: 36px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: #fff;\n  padding: 0 30px 0 10px;\n}\n\n.ftmCard {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-lg, 12px);\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-xs, 0 1px 2px rgba(15, 23, 42, 0.04));\n}\n\n.ftmTableCard {\n  overflow: visible;\n}\n.ftmTable {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.ftmTable th {\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  padding: 11px 14px;\n  text-align: left;\n  text-transform: uppercase;\n}\n.ftmTable td {\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  font-size: 13px;\n  padding: 13px 14px;\n  vertical-align: middle;\n}\n.ftmTable tbody tr {\n  cursor: pointer;\n}\n.ftmTable tbody tr:hover {\n  background: var(--slate-25, #fbfdff);\n}\n.ftmTable tbody tr:last-child td {\n  border-bottom: 0;\n}\n.ftmTable th:last-child,\n.ftmTable td:last-child {\n  text-align: right;\n  width: 1%;\n  white-space: nowrap;\n}\n\n.ftmNameCell {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.ftmNameCell strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-weight: 700;\n}\n.ftmNameCell small,\n.ftmAudit span {\n  display: block;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  margin-top: 1px;\n}\n.ftmAudit strong {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.ftmTags {\n  flex-wrap: wrap;\n}\n.ftmTagChip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  min-height: 22px;\n  border: 1px solid transparent;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1;\n  padding: 4px 9px;\n  white-space: nowrap;\n}\n.ftmTagChipButton {\n  cursor: pointer;\n}\n.ftmTagDot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0.75;\n}\n.ftmTagRemove {\n  border: 0;\n  background: transparent;\n  color: inherit;\n  cursor: pointer;\n  font-weight: 800;\n  opacity: 0.65;\n  padding: 0;\n}\n.ftmTagRemove:hover {\n  opacity: 1;\n}\n\n.ftmStatusBadge,\n.ftmTypeBadge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-height: 24px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 800;\n  padding: 0 10px;\n}\n.ftmStatusBadge {\n  background: var(--badge-neutral-bg, var(--slate-100, #f1f5f9));\n  color: var(--badge-neutral-text, var(--text-muted, #64748b));\n}\n.ftmTypeBadge--info {\n  background: var(--badge-info-bg, var(--blue-50, #eef6fc));\n  color: var(--badge-info-text, var(--blue-700, #155d8c));\n}\n.ftmStatusBadge--default {\n  background: var(--badge-info-bg, var(--blue-50, #eef6fc));\n  color: var(--badge-info-text, var(--blue-700, #155d8c));\n}\n\n.ftmMuted {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.ftmBanner {\n  border-radius: var(--radius-md, 8px);\n  margin-bottom: 12px;\n  padding: 12px 14px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.ftmBanner--warning {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  color: #9a3412;\n}\n\n.ftmEmpty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-height: 190px;\n  color: var(--text-muted, #64748b);\n  padding: 30px;\n  text-align: center;\n}\n.ftmEmpty svg {\n  color: var(--slate-300, #cbd5e1);\n  font-size: 28px;\n  margin-bottom: 4px;\n}\n.ftmEmpty strong {\n  color: var(--text-strong, #0f172a);\n}\n\n.ftmTagsLayout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 18px;\n  align-items: start;\n}\n.ftmCardHeader {\n  padding: 16px 18px 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.ftmCardHeader--toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.ftmCardHeader h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 16px;\n  font-weight: 800;\n}\n.ftmCardHeader p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n.ftmTagSearch {\n  width: 230px;\n  flex: 0 0 230px;\n}\n.ftmTagRows {\n  padding: 0 18px;\n}\n.ftmTagRow {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 58px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n.ftmTagRow:first-child {\n  border-top: 0;\n}\n.ftmTagGrip {\n  color: var(--slate-300, #cbd5e1);\n  cursor: grab;\n  font-size: 14px;\n  letter-spacing: -2px;\n}\n.ftmTagRowSpacer {\n  flex: 1;\n}\n.ftmTagUsage {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  white-space: nowrap;\n}\n.ftmTagRename {\n  flex: 1;\n}\n.ftmTagRename input:not([type='color']) {\n  height: 34px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  padding: 0 10px;\n}\n.ftmTagRename input[type='color'],\n.ftmColorControl input[type='color'] {\n  width: 38px;\n  height: 32px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 7px;\n  background: #fff;\n  padding: 2px;\n}\n.ftmTagCreateCard {\n  padding: 0 18px 18px;\n}\n.ftmTagCreateCard .ftmCardHeader {\n  margin: 0 -18px 16px;\n}\n.ftmColorControl span {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.ftmField {\n  margin-bottom: 14px;\n}\n.ftmField label,\n.ftmFieldLabel {\n  display: block;\n  color: var(--text-body, #334155);\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 6px;\n}\n.ftmField input:not([type='color']) {\n  height: 38px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: #fff;\n  padding: 0 11px;\n}\n.ftmField select {\n  width: 100%;\n  height: 38px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  padding: 0 32px 0 11px;\n  font-family: inherit;\n  font-size: 13px;\n}\n.ftmField select:disabled {\n  background-color: var(--slate-50, #f8fafc);\n  color: var(--text-body, #334155);\n  opacity: 1;\n}\n.ftmField input:disabled {\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n}\n\n.ftmBuilderPage {\n  min-height: calc(100vh - 76px);\n  background: var(--surface-page, #f8fafc);\n}\n.ftmBuilderTopbar {\n  position: sticky;\n  top: 0;\n  z-index: 8;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n  padding: 12px 22px;\n}\n.ftmBuilderBackLink {\n  display: inline-flex;\n  flex: 0 0 auto;\n  align-items: center;\n  gap: 7px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--blue-700, #155d8c);\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n}\n.ftmBuilderBackLink span {\n  font-size: 19px;\n  line-height: 1;\n}\n.ftmBuilderBackLink:hover {\n  color: var(--action-primary-hover, #176da6);\n  text-decoration: underline;\n}\n.ftmBuilderBackLink:disabled {\n  cursor: default;\n  opacity: 0.55;\n}\n.ftmBuilderBackDivider {\n  width: 1px;\n  height: 22px;\n  flex: 0 0 1px;\n  background: var(--border-subtle, #e2e8f0);\n}\n.ftmBuilderName {\n  min-width: 280px;\n  border: 1px solid transparent;\n  border-radius: var(--radius-sm, 6px);\n  background: transparent;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, inherit);\n  font-size: 17px;\n  font-weight: 800;\n  outline: 0;\n  padding: 4px 8px;\n}\n.ftmBuilderName:hover {\n  border-color: var(--border-subtle, #e2e8f0);\n}\n.ftmBuilderName:focus {\n  border-color: var(--border-brand, #2563eb);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(37, 99, 235, 0.16));\n  background: #fff;\n}\n.ftmBuilderMeta {\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n}\n.ftmBuilderSpacer {\n  flex: 1;\n}\n.ftmBuilderSettings {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.1fr) minmax(160px, 0.8fr) minmax(220px, 1fr) minmax(280px, 1.4fr);\n  gap: 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: #fff;\n  padding: 16px 22px;\n}\n.ftmRolesPanel,\n.ftmTagsPanel {\n  min-width: 0;\n}\n.ftmRoleChips {\n  flex-wrap: wrap;\n}\n.ftmRoleChip {\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  min-height: 28px;\n  padding: 0 10px;\n}\n.ftmRoleChip.isActive {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #155b8f);\n}\n.ftmRoleChip:hover {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n}\n.ftmTagEditorGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n.ftmTagEditorBox {\n  min-height: 58px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--slate-25, #fbfdff);\n  padding: 10px;\n}\n.ftmTagPicker {\n  display: flex;\n  min-height: 58px;\n  align-content: flex-start;\n  align-items: flex-start;\n  gap: 7px;\n  flex-wrap: wrap;\n  padding: 10px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: var(--slate-25, #fbfdff);\n}\n.ftmTagPicker button {\n  display: inline-flex;\n  min-height: 30px;\n  align-items: center;\n  gap: 6px;\n  padding: 0 10px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n}\n.ftmTagPicker button:hover {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n}\n.ftmTagPicker button.isSelected {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--blue-50, #eff6ff);\n  color: var(--blue-700, #155b8f);\n}\n.ftmTagEditorTitle {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  margin-bottom: 8px;\n  text-transform: uppercase;\n}\n.ftmBuilderSurface {\n  padding: 18px 22px 34px;\n}\n\n.ftmDetailsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n.ftmDetailsHero {\n  grid-column: 1 / -1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid #dbeafe;\n  border-radius: 10px;\n  background: #f8fbff;\n  padding: 14px;\n}\n.ftmDetailsTitle {\n  color: var(--text-strong, #0f172a);\n  font-size: 18px;\n  font-weight: 800;\n}\n.ftmDetailsMeta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  margin-top: 5px;\n}\n.ftmDetailsCard {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  padding: 12px;\n}\n.ftmDetailsCard--wide {\n  grid-column: 1 / -1;\n}\n.ftmDetailsLabel {\n  color: var(--text-muted, #64748b);\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n.ftmDeleteModal {\n  max-width: 480px;\n}\n.ftmDeleteBody {\n  display: flex;\n  align-items: flex-start;\n  gap: 11px;\n  text-align: left;\n  white-space: normal;\n}\n.ftmDeleteIcon {\n  display: inline-flex;\n  width: 32px;\n  height: 32px;\n  flex: 0 0 32px;\n  align-items: center;\n  justify-content: center;\n  border-radius: var(--radius-sm, 6px);\n  background: var(--red-50, #fdeef0);\n  color: var(--red-600, #c23648);\n  box-shadow: inset 0 0 0 1px var(--red-100, #f7cfd4);\n  font-size: 15px;\n  font-weight: 900;\n}\n.ftmHexInput {\n  width: 96px !important;\n  height: 34px !important;\n  border: 1px solid var(--border-default, #cbd5e1) !important;\n  border-radius: 7px !important;\n  padding: 0 9px !important;\n  font-family: ui-monospace, SFMono-Regular, Consolas, monospace !important;\n}\n.ftmColorPresets {\n  display: flex;\n  gap: 7px;\n  flex-wrap: wrap;\n  margin-top: 8px;\n}\n.ftmColorPresets button {\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  border: 2px solid #fff;\n  border-radius: 7px;\n  box-shadow: 0 0 0 1px var(--border-default, #cbd5e1);\n  cursor: pointer;\n}\n.ftmColorPresets button.isSelected {\n  box-shadow: 0 0 0 2px var(--action-primary, #227ebd);\n}\n.ftmDeleteMessage {\n  min-width: 0;\n}\n.ftmDeleteTitle {\n  color: var(--text-strong, #0f172a);\n  font-weight: 800;\n  margin-bottom: 5px;\n  overflow-wrap: anywhere;\n}\n.ftmDeleteText {\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.45;\n}\n.ftmDeleteModal .modal-header {\n  padding: 13px 16px !important;\n}\n.ftmDeleteModal .modal-header button {\n  width: 32px !important;\n  height: 32px !important;\n  border-radius: 8px !important;\n}\n.ftmDeleteModal .modal-body {\n  padding: 15px 16px !important;\n}\n.ftmDeleteModal .modal-footer {\n  padding: 10px 16px !important;\n}\n.ftmDeleteModal .modal-footer .btn {\n  min-height: 34px !important;\n  padding: 0 13px !important;\n  border-radius: var(--radius-md, 8px) !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n.ftmDeleteModal--danger .modal-footer .btn-primary {\n  border-color: var(--red-500, #da4453) !important;\n  background: var(--red-500, #da4453) !important;\n  color: #fff !important;\n}\n.ftmDeleteModal--danger .modal-footer .btn-primary:hover {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n}\n.ftmCreateTypes {\n  align-items: stretch;\n  flex-direction: column;\n}\n\n@media (max-width: 1100px) {\n  .ftmTypeGrid,\n  .ftmBuilderSettings,\n  .ftmTagsLayout {\n    grid-template-columns: 1fr;\n  }\n  .ftmControlsSpacer {\n    display: none;\n  }\n}\n\n@media (max-width: 760px) {\n  .ftmPage {\n    padding: 14px;\n  }\n  .ftmPage--modern {\n    padding: 0 0 24px;\n  }\n  .ftmPage--modern .ftmHeader {\n    width: calc(100% + 24px);\n    min-height: 0;\n    margin: -20px -12px 16px;\n    padding: 14px 16px;\n  }\n  .ftmPage--modern .ftmMainCard {\n    padding: 14px;\n  }\n  .ftmPage--modern .ftmHeader > .ftmTabs {\n    width: 100%;\n    min-height: 42px;\n  }\n  .ftmPage--modern .ftmHeader > .ftmTabs button::after {\n    bottom: 0;\n  }\n  .ftmHeader,\n  .ftmBuilderTopbar,\n  .ftmControls {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .ftmBuilderBackLink {\n    align-self: flex-start;\n  }\n  .ftmBuilderBackDivider {\n    width: 100%;\n    height: 1px;\n    flex-basis: 1px;\n  }\n  .ftmHeaderActions {\n    width: 100%;\n  }\n  .ftmHeaderActions .ftmButton {\n    flex: 1;\n  }\n  .ftmSearchField,\n  .ftmControls select,\n  .ftmBuilderName {\n    width: 100%;\n    min-width: 0;\n  }\n  .ftmTable {\n    min-width: 860px;\n  }\n  .ftmTableCard {\n    overflow-x: auto;\n  }\n  .ftmTagEditorGrid,\n  .ftmDetailsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.ftmHelpContent {\n  display: grid;\n  gap: 12px;\n  text-align: left;\n}\n\n.ftmHelpContent div {\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 8px;\n  background: #fff;\n  padding: 12px;\n}\n\n.ftmHelpContent strong {\n  display: block;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.ftmHelpContent span {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.ftmFilterOverlay {\n  position: fixed;\n  z-index: 1050;\n  inset: 0;\n  display: flex;\n  justify-content: flex-end;\n  background: rgba(15, 23, 42, 0.28);\n}\n.ftmFilterDrawer {\n  display: flex;\n  width: min(390px, 100vw);\n  height: 100%;\n  flex-direction: column;\n  background: var(--surface-card, #fff);\n  box-shadow: -12px 0 30px rgba(15, 23, 42, 0.16);\n}\n.ftmFilterHeader {\n  display: flex;\n  min-height: 34px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  margin: 18px 18px 0;\n  padding: 0 0 12px;\n}\n.ftmFilterHeader h2 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 16px;\n  font-weight: 800;\n}\n.ftmFilterHeader p {\n  margin: 3px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.ftmFilterBody {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n.ftmFilterSection + .ftmFilterSection {\n  margin-top: 22px;\n}\n.ftmFilterChips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.ftmFilterChips button {\n  min-height: 30px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 999px;\n  background: #fff;\n  color: var(--text-body, #334155);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 0 11px;\n}\n.ftmFilterChips button.isActive {\n  border-color: var(--action-primary, #227ebd);\n  background: var(--action-primary, #227ebd);\n  color: #fff;\n}\n.ftmTagListCard {\n  overflow: visible;\n}\n.ftmTagToolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n}\n.ftmTagToolbar .ftmSearchField {\n  position: relative;\n}\n.ftmTagToolbar .ftmSearchField input {\n  padding-right: 36px;\n}\n.ftmTagToolbar .ftmSearchField button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.ftmTagToolbar .ftmSearchField button:hover {\n  background: var(--slate-100, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.ftmTagTable th:nth-child(2),\n.ftmTagTable td:nth-child(2) {\n  width: 180px;\n}\n.ftmTagTable tbody tr {\n  cursor: default;\n}\n.ftmTagModalBody {\n  padding-top: 2px;\n}\n.ftmTagPreviewField {\n  margin-bottom: 2px;\n  padding: 12px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: var(--radius-md, 8px);\n  background: var(--slate-25, #fbfdff);\n}\n.ftmTagChip--previewDisabled {\n  border-color: var(--border-subtle, #e2e8f0) !important;\n  background: var(--surface-sunken, #f1f5f9) !important;\n  color: var(--text-subtle, #94a3b8) !important;\n  opacity: 0.78;\n}\n\n.ftmRowActions {\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 6px;\n}\n\n.ftmRowEditButton,\n.ftmRowMenuButton {\n  display: inline-flex;\n  height: 32px;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: var(--radius-md, 8px);\n  background: var(--surface-card, #fff);\n  color: var(--text-body, #334155);\n  font-family: inherit;\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.ftmRowEditButton {\n  min-width: 52px;\n  padding: 0 12px;\n}\n\n.ftmRowMenuButton {\n  width: 34px;\n  padding: 0;\n  letter-spacing: 1px;\n}\n\n.ftmRowEditButton:hover,\n.ftmRowMenuButton:hover,\n.ftmRowMenuButton[aria-expanded='true'] {\n  border-color: var(--border-brand, #6fb1df);\n  background: var(--blue-50, #eef6fc);\n  color: var(--blue-700, #155d8c);\n}\n\n.ftmRowMenu {\n  position: absolute;\n  z-index: 40;\n  top: calc(100% + 5px);\n  right: 0;\n  width: 170px;\n  padding: 6px;\n  border: 1px solid var(--border-subtle, #dbe3ec);\n  border-radius: 10px;\n  background: var(--surface-card, #fff);\n  box-shadow: var(--shadow-lg, 0 16px 36px rgba(15, 23, 42, 0.16));\n  text-align: left;\n}\n\n.ftmRowMenu button {\n  display: flex;\n  width: 100%;\n  min-height: 34px;\n  align-items: center;\n  padding: 7px 10px;\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-body, #334155);\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 650;\n  text-align: left;\n  cursor: pointer;\n}\n\n.ftmRowMenu button:hover {\n  background: var(--surface-hover, #f1f5f9);\n}\n\n.ftmRowMenu button.isDanger {\n  color: var(--red-600, #c4313f);\n}\n\n.ftmRowMenu button.isDanger:hover {\n  background: var(--red-50, #fff1f2);\n}\n.ftmFilterFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n  padding: 16px 20px;\n}\n\n.ftmFilterFooter > div {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ftmPagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 14px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n@media (max-width: 760px) {\n  .ftmCardHeader--toolbar {\n    align-items: stretch;\n    flex-direction: column;\n  }\n  .ftmTagSearch {\n    width: 100%;\n    flex-basis: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
